/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BaseCloneData,
  ClonedWebOrder,
  Decimal,
  ErrorResponse,
  MassUnit,
  TagWebOrdersRequestBody,
  TagWebOrdersResponse,
  WebOrder,
  WebOrderList,
  WebOrderRequestBody,
  WebRateList,
  WebRatesBulkRequest,
  WebRatesBulkResponse,
  WebShipment,
  WebShipmentPatchBody,
  WebShipmentResponse,
  WebShipmentsBulkPatchRequest,
  WebShipmentsBulkResponse,
  WebTransactionResponse,
  WebTransactionsBulkResponse,
  WebTransactionsExtendedResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class WebOrders<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetWebOrders
   * @request GET:/web_orders
   */
  getWebOrders = (
    query?: {
      /** Limit on the number of results to return per page */
      results?: number;
      /** Page number of results */
      page?: number;
      /** Filter orders by whether or not they're cross-border */
      destination?: 'domestic' | 'international';
      /**
       * Filter for orders created on or before a given date
       * @format date-time
       */
      end_date?: string;
      /** Query for specific orders by ID */
      id?: string[];
      /** Filter orders by items they contain */
      item?: string[];
      /** Filter by maximum mass */
      mass_max?: Decimal;
      /** Filter by minimum mass */
      mass_min?: Decimal;
      /** Unit for mass_min and mass_max, required if either of those is provided */
      mass_unit?: MassUnit;
      /** Sort order for the sort_by property */
      order_by?: 'asc' | 'desc';
      /** Filter orders by status */
      order_status?: (
        | 'unknown'
        | 'awaitpay'
        | 'paid'
        | 'refunded'
        | 'cancelled'
        | 'partially_fulfilled'
        | 'shipped'
      )[];
      /** Filter by customer-selected shipping method */
      shipping_method?: string[];
      /** Filter by shop application on which the order was created */
      shop_app?: string;
      /** Property by which to sort orders */
      sort_by?: 'created_date' | 'relevance';
      /**
       * Filter for orders created on or after a given date
       * @format date-time
       */
      start_date?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<WebOrderList, ErrorResponse>({
      path: `/web_orders`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name CreateWebOrder
   * @request POST:/web_orders
   */
  createWebOrder = (data: WebOrderRequestBody, params: RequestParams = {}) =>
    this.request<WebOrder, ErrorResponse>({
      path: `/web_orders`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name GetWebOrder
   * @request GET:/web_orders/{WebOrderId}
   */
  getWebOrder = (webOrderId: string, params: RequestParams = {}) =>
    this.request<WebOrder, ErrorResponse>({
      path: `/web_orders/${webOrderId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name CloneWebOrder
   * @request POST:/web_orders/{WebOrderId}/clone
   */
  cloneWebOrder = (webOrderId: string, params: RequestParams = {}) =>
    this.request<BaseCloneData, ErrorResponse>({
      path: `/web_orders/${webOrderId}/clone`,
      method: 'POST',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name GetClonedWebOrder
   * @request GET:/web_orders/{WebOrderId}/clone/{ClonedWebOrderId}
   */
  getClonedWebOrder = (webOrderId: string, clonedWebOrderId: string, params: RequestParams = {}) =>
    this.request<ClonedWebOrder, ErrorResponse>({
      path: `/web_orders/${webOrderId}/clone/${clonedWebOrderId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * @description Create a return shipment for the order. This deletes any pending return shipments on the order.
   *
   * @name CreateReturnShipmentFromOrder
   * @request POST:/web_orders/{WebOrderId}/return
   */
  createReturnShipmentFromOrder = (webOrderId: string, params: RequestParams = {}) =>
    this.request<WebShipmentResponse, ErrorResponse>({
      path: `/web_orders/${webOrderId}/return`,
      method: 'POST',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name GetWebOrderTransactions
   * @request GET:/web_orders/{WebOrderId}/transactions
   */
  getWebOrderTransactions = (webOrderId: string, params: RequestParams = {}) =>
    this.request<WebTransactionsExtendedResponse, ErrorResponse>({
      path: `/web_orders/${webOrderId}/transactions`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name UpdateBulkWebOrders
   * @request PATCH:/web_orders/shipments
   */
  updateBulkWebOrders = (data: WebShipmentsBulkPatchRequest, params: RequestParams = {}) =>
    this.request<WebShipmentsBulkResponse, ErrorResponse>({
      path: `/web_orders/shipments`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name GetBulkWebOrderRates
   * @request GET:/web_orders/rates
   */
  getBulkWebOrderRates = (data: WebRatesBulkRequest, params: RequestParams = {}) =>
    this.request<WebRatesBulkResponse, ErrorResponse>({
      path: `/web_orders/rates`,
      method: 'GET',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Get a list of transactions
   *
   * @name GetTransactions
   * @request GET:/web_orders/transactions
   */
  getTransactions = (params: RequestParams = {}) =>
    this.request<WebTransactionsExtendedResponse, any>({
      path: `/web_orders/transactions`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name PurchaseBulkLabels
   * @request POST:/web_orders/transactions
   */
  purchaseBulkLabels = (data: WebRatesBulkRequest, params: RequestParams = {}) =>
    this.request<WebTransactionsBulkResponse, ErrorResponse>({
      path: `/web_orders/transactions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Create a return shipment for the transaction. This automatically creates an order and outbound shipment if the transaction is not associated with any, and it deletes any pending returns on the order.
   *
   * @name CreateReturnShipmentFromTransaction
   * @request POST:/web_orders/transactions/{TransactionId}/return
   */
  createReturnShipmentFromTransaction = (transactionId: string, params: RequestParams = {}) =>
    this.request<WebShipmentResponse, ErrorResponse>({
      path: `/web_orders/transactions/${transactionId}/return`,
      method: 'POST',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name UpdateWebOrder
   * @request PATCH:/web_orders/{WebOrderId}/shipments/{ShipmentId}
   */
  updateWebOrder = (
    webOrderId: string,
    shipmentId: string,
    data: WebShipmentPatchBody,
    params: RequestParams = {},
  ) =>
    this.request<WebShipment, ErrorResponse>({
      path: `/web_orders/${webOrderId}/shipments/${shipmentId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Creates and returns a copy of a WebShipment for which a label has been purchased, or which encountered an error during label purchase, to prepare it to be purchased again
   *
   * @name ResetWebShipment
   * @request POST:/web_orders/{WebOrderId}/shipments/{ShipmentId}/refresh
   */
  resetWebShipment = (webOrderId: string, shipmentId: number, params: RequestParams = {}) =>
    this.request<WebShipment, ErrorResponse>({
      path: `/web_orders/${webOrderId}/shipments/${shipmentId}/refresh`,
      method: 'POST',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name GetWebOrderRates
   * @request GET:/web_orders/{WebOrderId}/shipments/{ShipmentId}/rates
   */
  getWebOrderRates = (webOrderId: string, shipmentId: string, params: RequestParams = {}) =>
    this.request<WebRateList, ErrorResponse>({
      path: `/web_orders/${webOrderId}/shipments/${shipmentId}/rates`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * @description Creates a return shipment from an outbound shipment. This deletes any pending return shipments for the outbound one.
   *
   * @name CreateReturnShipmentFromOutboundShipment
   * @request POST:/web_orders/{WebOrderId}/shipments/{ShipmentId}/return
   */
  createReturnShipmentFromOutboundShipment = (
    webOrderId: string,
    shipmentId: number,
    params: RequestParams = {},
  ) =>
    this.request<WebShipmentResponse, ErrorResponse>({
      path: `/web_orders/${webOrderId}/shipments/${shipmentId}/return`,
      method: 'POST',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name PurchaseLabel
   * @request POST:/web_orders/{WebOrderId}/shipments/{ShipmentId}/transactions
   */
  purchaseLabel = (
    webOrderId: string,
    shipmentId: string,
    data: {
      rate_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<WebTransactionResponse, ErrorResponse>({
      path: `/web_orders/${webOrderId}/shipments/${shipmentId}/transactions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name TagWebOrders
   * @request POST:/web_orders/tags
   */
  tagWebOrders = (data: TagWebOrdersRequestBody, params: RequestParams = {}) =>
    this.request<TagWebOrdersResponse, ErrorResponse>({
      path: `/web_orders/tags`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name UntagWebOrders
   * @request DELETE:/web_orders/tags
   */
  untagWebOrders = (data: TagWebOrdersRequestBody, params: RequestParams = {}) =>
    this.request<TagWebOrdersResponse, ErrorResponse>({
      path: `/web_orders/tags`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
